export default __webpack_public_path__ + "5aa3eacc4b2f6278e7b82c1ba2a07d2c.png";